import React from "react";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../../../Button/Button";
import redeemed_collectible from "../../../../../assets/images/redeemed_collectible.png";
import { redeemedCollectibleStyles as styles } from "./redeemedCollectible.tailwind";

const RedeemedCollectibleModal = ({ isOpen, onClose }) => {
  return (
    <Modal open={isOpen} onClose={onClose} disableAutoFocus>
      <div className={styles.container}>
        {/* Image container */}
        <div className={styles.imageContainer}>
          <img
            src={redeemed_collectible}
            alt="Collectible"
            className={styles.image}
          />

          {/* Close button */}
          <button onClick={onClose} className={styles.closeButton}>
            <CloseIcon sx={{ fontSize: "12px" }} />
          </button>
          {/* Text overlay at the bottom */}
          <div className={styles.textOverlay}>
            <p className={styles.message}>
              You Have Redeemed Limited Edition Collectible
            </p>
            <Button
              variant="theme"
              className="!px-[28px] !py-1 hidden screen-500:flex"
              onClick={onClose}
            >
              Close
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default RedeemedCollectibleModal;
